import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Box, Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function Hurma() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo hurma-logo"
          src="/Images/barometer/partners/hurma_logo.png"
          alt="partner logo"
        />
      }
      heading="Інформаційний партнер"
    >
      <Flex direction="column" gap="5">
        <BlueField>
          HURMA – перша українська HRIS/ATS-систему, що гарантує найвищі
          стандарти захисту даних.
        </BlueField>

        <p>
          Розробили комплексне рішення, яке закриває всі потреби HR, рекрутингу
          та цілепокладання, інтегруючи власні AI/ML-технології для максимальної
          економії часу та бюджету.
        </p>

        <Box>
          <Box mb="4">
            <p>Що інтегровано у HURMA для вашого успіху:</p>
          </Box>
          <ul className="advantages">
            <li>
              Автоматизація рекрутингу (ATS): від розміщення вакансій до оферу,
              з інтеграцією популярних job-порталів.
            </li>
            <li>
              Управління персоналом (HRIS): облік, відпустки, адаптація,
              Payroll.
            </li>
            <li>OKR-система: прозоре управління цілями компанії та команд</li>
            <li>
              Continuous Feedback: автоматизований збір зворотного зв&apos;язку
              (1:1, Performance Review, фідбек 360).
            </li>
            <li>
              Аналітика: комплексні звіти, що вимірюють ефективність та
              допомагають в стратегуванні.
            </li>
          </ul>
        </Box>

        <p>
          HURMA перетворила рутину на автоматизацію, щоб ви заощаджували до 60
          годин на місяць і зосередились на головному – розвитку вашої команди.
        </p>

        <p>
          <BlueField>HURMA</BlueField> – це більше, ніж система. Це ваш партнер
          для ефективного управління та зростання компанії!
        </p>
      </Flex>
    </PartnerCard>
  );
}
